export const REGISTER_REQUEST="REQUSET_REQUSET";
    export const REGISTER_SUCCESS="REQUSET_SUCCESS";
    export const REGISTER_FAILURE="REQUSET_FAILURE";


    export const LOGIN_REQUEST="LOGIN_REQUEST";
    export const LOGIN_SUCCESS="LOGIN_SUCCESS";
    export const LOGIN_FAILURE="LOGIN_FAILURE";